import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow-down",
  "use": "default-arrow-down-usage",
  "viewBox": "0 0 20 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 11\" id=\"default-arrow-down\"><path fill-rule=\"evenodd\" d=\"M9.5 10.579a1.499 1.499 0 01-1.4-.4L.322 2.4A1.5 1.5 0 112.443.279L9.5 7.336 16.557.279A1.5 1.5 0 0118.678 2.4L10.9 10.178c-.38.38-.913.514-1.4.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol